"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  SuccessMessageForSaving: 'Your changes have been saved.',
  ErrorMessageFromServer: 'Bad response from server.',
  DateTimeFormat: {
    shortDate: 'MM/DD/YYYY',
    shortTime: 'HH:mm',
    shortTimeAMPM: 'hh:mm A',
    shortDayOfWeek: 'ddd',
    dayOfWeek: 'dddd',
    shortMonth: 'MMMM YYYY',
    dateTimeAMPM: 'MM/DD/YYYY hh:mm A',
    shortYear: 'MM/DD/YY',
    longDate: 'lll',
    dateTimeShortYearAMPM: 'MM/DD/YY hh:mm A',
    longDateFormat: 'MMMM DD, YYYY',
    longDateTimeFormat: 'MMMM DD, YYYY hh:mm A',
    UTC: 'UTC',
    EXECUTION_DATE_TIME: 'MMM DD, YYYY [at] h:mm A'
  },
  TimeConstraint: {
    minutes: {
      step: 15,
      min: 0
    },
    startTime: {
      hours: 9,
      minutes: 0,
      seconds: 0
    },
    endTime: {
      hours: 17,
      minutes: 0,
      seconds: 0
    }
  },
  Permissions: {
    Communications: {
      COMMUNICATIONS: '/communications/*'
    }
  },
  LANGUAGE_PREFERENCES: [{
    value: 'es',
    label: 'Spanish'
  }, {
    value: 'en',
    label: 'English'
  }],
  FORMS: {
    SET_UP_CAMPAIGN_FORM: 'SetUpCampaignForm'
  },
  CHANNEL_TYPE: {
    EMAIL: 'Email',
    SMS: 'SMS',
    POSTCARD: 'Postcard',
    LETTER: 'Letter'
  },
  LANGUAGE_TYPE: {
    ENGLISH: 'English',
    SPANISH: 'Spanish'
  },
  COLOR_OUTPUT: {
    BLACK_WHITE: 'Black & White',
    COLOR: 'Color'
  },
  DOUBLE_SIZE: {
    YES: 'Yes',
    NO: 'No'
  },
  POSTCARD_SIZE: {
    FOUR_SIX: '4x6',
    SIX_NINE: '6x9',
    SIX_ELEVEN: '6x11'
  },
  VALIDATION_TYPES_DATE_TIME_PICKER: {
    FUTURE_DATE_TIME: 'DATE_TIME_ONLY_FUTURE_DATE',
    PAST_DATE_TIME: 'DATE_TIME_ONLY_PAST_DATE',
    ONE_WEEK_FUTURE: 'ONE_WEEK_FUTURE'
  },
  MAX_FONT_SIZE_TEMPLATE: 16,
  PARAM_TYPE: {
    QUERY_STRING: 'Query String',
    PATH_VARIABLE: 'Path Variabel',
    BOTH: 'Both'
  },
  PARTICIPANT_STATUS: {
    ACTIVE: 'ACTIVE',
    DEACTIVATED: 'DEACTIVATED',
    WITHDRAWN: 'WITHDRAWN'
  },
  PARTICIPANTS_SIZE_PER_PAGE: 20
};
exports.default = _default;